import { Button } from "@material-ui/core";
import { Fragment } from "react";
import { useCallCenter } from "../../../../context/CallCenterContext";
import { useLogin } from "../../../../context/LoginContext";
import { useStyle } from "../../../../context/StyleContext";

export default function ControlesCallCenter() {
    const {
        consultaIniciada,
        entCallCenter,
        usuarioColaborador,
        temporizador,
        handleClickIniciarConsulta,
        handleClickReiniciarChat,
        handleClickDirectorio,
        handleClickFinalizarConsulta,
        handleClickReciclarConsulta,
    } = useCallCenter();
    const { classes } = useStyle();
    const { usuarioPermisos } = useLogin();

    const permisos = usuarioPermisos["4"].Submodulos["1"];

    return (
        <Fragment>
            <span className="rob-con bold size-20 vertical-align-middle mar-right-30">
                Consulta: {temporizador.hora.toLocaleString("en", { minimumIntegerDigits: 2 })}:
                {temporizador.minuto.toLocaleString("en", { minimumIntegerDigits: 2 })}:
                {temporizador.segundo.toLocaleString("en", { minimumIntegerDigits: 2 })}
            </span>
            {!consultaIniciada && !entCallCenter
                ? permisos.Botones["2"] && ( //Iniciar consulta
                      <Button
                          variant="contained"
                          className={classes.buttonCallCenter}
                          onClick={handleClickIniciarConsulta}
                          disabled={!usuarioColaborador}
                      >
                          {permisos.Botones["2"].Nombre}
                      </Button>
                  )
                : permisos.Botones["3"] && ( //Finalizar consulta
                      <Button
                          variant="contained"
                          className={classes.buttonCallCenter}
                          onClick={() => handleClickFinalizarConsulta(false)}
                          disabled={!usuarioColaborador}
                      >
                          {permisos.Botones["3"].Nombre}
                      </Button>
                  )}
            {permisos.Botones["4"] && //Reiniciar Chat
                (consultaIniciada ? (
                    <Button
                        variant="contained"
                        className={classes.buttonDanger}
                        onClick={handleClickReciclarConsulta}
                        disabled={!usuarioColaborador}
                    >
                        Reciclar consulta
                    </Button>
                ) : (
                    <Button
                        variant="contained"
                        className={classes.buttonCallCenter}
                        onClick={handleClickReiniciarChat}
                        disabled={!usuarioColaborador}
                    >
                        {permisos.Botones["4"].Nombre}
                    </Button>
                ))}

            {permisos.Botones["5"] && ( //Directorio
                <Button variant="contained" className={classes.buttonCallCenter} onClick={handleClickDirectorio}>
                    {permisos.Botones["5"].Nombre}
                </Button>
            )}
        </Fragment>
    );
}
